var currentEditCountry = "";
$(function(){
	//Fill the country selector with remaining countries
	for(var c = 0; c < sharedFunctions.listOfCountries.length; c++){
		if(sharedFunctions.listOfCountries[c].a !== 'US' && sharedFunctions.listOfCountries[c].a !== 'CA' && sharedFunctions.listOfCountries[c].a !== 'GB'){
			var name = sharedFunctions.listOfCountries[c].n;
			$('#profileForm #country').append('<option value=\"'+sharedFunctions.listOfCountries[c].a+'\">'+name+'</option>');
		}
	}
	$('#profileForm #country').change();
})
$('#profileForm #country').on('change', function(){
	rebuildEditAddressFields($(this).val());
});
$('#profileForm #country').on('blur', function(){
	if($(this).val() !== currentEditCountry)     //PREVENT FORM FROM RELOADING IF COUNTRY IS UNCHANGED
		rebuildEditAddressFields($(this).val());
});
function rebuildEditAddressFields(countryCode){
	if(countryCode == 'US'){
		($('#phone1').parent()).show();
		($('#phone2').parent()).show();
	}else{
		($('#phone1').parent()).hide();
		($('#phone2').parent()).hide();
	}
	currentEditCountry = countryCode;
	var fields = sharedFunctions.getAddressFieldsByCountryCode(countryCode);  //found in addressFields.js
	var finalForm = '';
	var foundParts = {}
	for(var i = 0; i < fields.length; i++){
		var f = fields[i].name;
		foundParts[f] = fields[i];
	}
	var order = ['street1','street2','city','state','zipcode'];
	for(var index in order){
		if(foundParts[order[index]])
			finalForm += buildFormItem({    //located in donate.js
				item: foundParts[order[index]],
				classes: 'form-group',          //Classes to add to div(space seperated)
				label: 1,
				inputClasses: 'form-control pro1'
			})
	}
	//Replace original address fields
	$('#address').empty();
	$('#address').append(finalForm);
}
var changeEmail = function(){;
	var member = fetchMemberInfo();
	var oldEmail = member.email;
	var newEmail = $('#email').val();
	if(newEmail !== oldEmail && newEmail !== ""){
		if(newEmail.match("^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$")){
			member.newEmail = newEmail;
			$.ajax({
				type: 'POST',
				url: '/v12a21yz',
				data: member,
				success: function(response){
					if(!response.success){
						errorDisplayAndTrack("An error occurred. Please try logging out and logging back in before trying again.");
					}else{
						var newEmail = $('#email').val();
						saveMemberInfo({email:newEmail});
						//successDisplay("Email address has been updated.");
						changeAddress(true);
					}
				},
				dataType: 'json'
			})
		}else{
			errorDisplayAndTrack("Invalid email. Please use the format email@domain.com");
			$('#email').val(member.email);
		}
	}else{
		$('#email').val(member.email);
		changeAddress(false);
	}
}
var changeAddress = function(emailChanged){
	var thisForm = $('#profileForm');
	var memberArray = thisForm.serializeArray();
	var oldMember = fetchMemberInfo();
	var memberChanges = {};
	for(var i in memberArray){
		var name = (memberArray[i].name == 'zipcode')? 'zip' : memberArray[i].name;
		if(memberArray[i].value !== "" && memberArray[i].value !== "NULL")
			memberChanges[name] = memberArray[i].value;
		else if(memberArray[i].value == ""){
			if(oldMember[name] !== "")
				memberChanges[name] = memberArray[i].value;
		}
	}
	if(typeof memberChanges.phone1 !== 'undefined' && memberChanges.phone1 !== ""){
		if(!memberChanges.phone1.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)){
			errorDisplayAndTrack("Invalid home phone. Please use the format xxx-xxx-xxxx");
			return;
		}
	}
	if(typeof memberChanges.phone2 !== 'undefined' && memberChanges.phone2 !== "") {
		if(!memberChanges.phone2.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)){
			errorDisplayAndTrack("Invalid cell phone. Please use the format xxx-xxx-xxxx");
			return;
		}
	}
	var update = saveMemberInfo(memberChanges);
	if(update){
		$('#editModal').modal('hide');
		$.ajax({
			type: "POST",
			url: '/hn66p4i3',
			data: {},
			success: function(data){
				if(data.success){
					fillProfileInfo();
					var updatedMember = fetchMemberInfo();
					var status = sharedFunctions.addressCompleted(updatedMember);
					if(status == 'empty'){
						successDisplay("Success!", "Your profile has been updated.", "#login-container-container");
						progressTiles(true, false);
						verified(false);
					}else if(status == 'partial'){
						successDisplay("Success!", "Your profile has been updated.", "#login-container-container");
						progressTiles(true, true);
						verified(false);
					}else{
						successDisplay("Success!", "Your profile has been updated. Thank you for becoming a verified member.", "#login-container-container");
						progressTiles(false);
						verified(true);
					}
				}else{
					errorDisplayAndTrack("An error occurred. Please try logging out and logging back in before trying again.");
				}
			},
			dataType: 'json'
		})
	}else if(emailChanged){
		successDisplay("Success!", "Your email has been updated.", "#login-container-container");
	}
}
var manageEmail = function(){
	var email = $('#email').val();
	var win = window.open('/subscriptions?email='+email, '_blank');
}

//Look for directed profile page title, and apply text emphasis to the following phrases
var emphasisPhrases = ['free gift'];
var titleTag = $('p.profileShort');
if(titleTag && titleTag.length){
	var title = $(titleTag).text();
	var regex = "(";
	for(var i = 0; i < emphasisPhrases.length; i++){
		regex += emphasisPhrases[i];
		if(i !== emphasisPhrases.length - 1) regex += "|";
	}
	regex += ")";
	var tester = new RegExp(regex, 'gi');
	var newtitle = title.replace(tester, function(orig){
		return "<span class=\"profileEmphasis\">"+orig+"</span>";
	})
	if(newtitle !== title) $(titleTag).html(newtitle);
}